export interface IDatiqColor {
    [key: string]: string;
}

export const datPool: IDatiqColor = {
    '100': '#AFF2FF',
    '200': '#74EAFF',
    '300': '#00E1FF',
    '400': '#00DAFD',
    '500': '#00C1E5',
    '600': '#00ACC9',
    '700': '#0097AF',
};

export const datRegal: IDatiqColor = {
    '050': '#E7CEF4',
    '100': '#E1BDF5',
    '200': '#CE91F0',
    '300': '#B962EB',
    '400': '#9900E0',
    '500': '#6D0AD3',
    '600': '#5000C5',
    '700': '#3600A3',
};

export const datGrey: IDatiqColor = {
    '050': '#f6f7f9',
    '100': '#e9ecf1',
    '200': '#c7cfd6',
    '300': '#9ca5af',
    '400': '#7b8793',
    '500': '#636d79',
    '600': '#4e5a65',
    '700': '#3b4854',
    '800': '#2d3943',
    '900': '#192129',
    '1000': '#0a0d10',
};

export const datBlue: IDatiqColor = {
    '050': '#e9effe',
    '100': '#c7d7fa',
    '200': '#9fbbf7',
    '300': '#5789f4',
    '400': '#1c60f2',
    '500': '#0046e0',
    '600': '#0041cd',
    '700': '#0032a8',
    '800': '#002480',
    '900': '#001a66',
};

export const datSuccess: IDatiqColor = {
    '050': '#e4ffde',
    '100': '#cdf8c3',
    '200': '#a9f39b',
    '300': '#7fed6e',
    '400': '#00e107',
    '500': '#00d000',
    '600': '#00ba00',
    '700': '#008002',
};

export const datSignalRed: IDatiqColor = {
    '050': '#fff4f3',
    '100': '#ffe6e5',
    '200': '#ff9c99',
    '300': '#ff6c66',
    '400': '#ff211a',
    '500': '#e10600',
    '600': '#ad0600',
    '700': '#7a0400',
};

export const datSignalYellow: IDatiqColor = {
    '100': '#fff9c0',
    '200': '#fff595',
    '300': '#fef167',
    '400': '#fae700',
    '500': '#ffd700',
    '600': '#ffc000',
    '700': '#ffa700',
};

export const datFlame: IDatiqColor = {
    '050': '#fff3d4',
    '100': '#ffeab2',
    '200': '#ffdd81',
    '300': '#ffd14d',
    '400': '#ffbc04',
    '500': '#ffae00',
    '600': '#ff9b02',
    '700': '#fe6a07',
};

export const datDataColors: IDatiqColor = {
    Loads: datRegal['700'],
    Trucks: datPool['700'],
    Contract: datBlue['400'],
    Spot: datFlame['400'],
    AllRateTypes: datRegal['400'],
    RatePerMile: datPool['400'],
    Benchmark: datGrey['300'],
    Multiline: datGrey['500'],
};
